/**
 * column-layout.js
 *
 * Watches animated column layouts and stage progress grids.
 * Adds .is-visible when each enters the viewport - CSS handles
 * the staggered entrance via animation-delay on --stage-index.
 *
 * Targets:
 *   .k-column-layout--animate   column_layout paragraph
 *   [data-k-column-animate]     stage_progress card grid
 */

(function (Drupal) {
  "use strict";

  var SELECTOR = ".k-column-layout--animate, [data-k-column-animate]";
  var OBSERVED_CLASS = "k-col-observed";

  function observe(elements) {
    if (!("IntersectionObserver" in window)) {
      elements.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -3% 0px",
      },
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Drupal behavior ── */
  if (typeof Drupal !== "undefined") {
    Drupal.behaviors.kColumnLayout = {
      attach: function (context) {
        var targets = Array.prototype.slice.call(
          context.querySelectorAll
            ? context.querySelectorAll(
                SELECTOR + ":not(." + OBSERVED_CLASS + ")",
              )
            : [],
        );
        targets.forEach(function (el) {
          el.classList.add(OBSERVED_CLASS);
        });
        if (targets.length) {
          observe(targets);
        }
      },
    };
  } else {
    /* Standalone */
    function init() {
      var targets = Array.prototype.slice.call(
        document.querySelectorAll(SELECTOR),
      );
      observe(targets);
    }
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", init)
      : init();
  }
})(typeof Drupal !== "undefined" ? Drupal : {});
